// extracted by mini-css-extract-plugin
export var arrow = "_2r-6";
export var changeItem = "_2r-3";
export var changesHeader = "_2r-1";
export var changesList = "_2r-2";
export var container = "_2r-0";
export var pathLabel = "_2r-4";
export var value = "_2r-7";
export var valuesContainer = "_2r-5";